// extracted by mini-css-extract-plugin
export default {"title":"Hemoglobin_title__ZqsB5","readingInput":"Hemoglobin_readingInput__R0tQZ","readingsRow":"Hemoglobin_readingsRow__TtCvy"};